// /invoices szegmens layout-ja — CSAK auth-guard + <Outlet/>. A tényleges lapok a gyerek-route-okban:
// invoices.index (lista) · invoices.new (új számla) · invoices.$id (részlet) · invoices.$id.edit (szerkesztő).
//
// KRITIKUS (a `tickets.tsx`-nél MÁR egyszer megtörtént hiba): a listát KÜLÖN index-route adja, NEM ez a
// layout. Amíg a lista volt a `/invoices` komponense, a fájl-alapú routing a `/invoices/new` és a
// `/invoices/$id` lapokat a SZÜLŐ Outlet-jébe rendelte — Outlet viszont nem volt, így az URL váltott, a
// felület pedig a listán maradt („nem nyílik meg a szerkesztés / az Új számla"). A clients és a tickets
// szegmens ugyanezt a mintát követi.
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireAuth } from '@/lib/auth';

export const Route = createFileRoute('/invoices')({
  beforeLoad: () => requireAuth(),
  component: InvoicesLayout,
});

function InvoicesLayout(): JSX.Element {
  return <Outlet />;
}
